export default "__VITE_ASSET__2d3eb968__"